import {
  ChevronRightRounded,
  RadioButtonChecked,
  RadioButtonUnchecked,
} from '@material-ui/icons';

import makeClasses from './RightNavOptionIcon.style';

export function RightNavOptionIcon(props: Props) {
  const { isChecked } = props;
  const _classes = makeClasses();
  return (
    <>
      <ChevronRightRounded className={_classes.right} />
      {isChecked ? (
        <RadioButtonChecked className={_classes.check} />
      ) : (
        <RadioButtonUnchecked className={_classes.check} />
      )}
    </>
  );
}

interface Props {
  isChecked: boolean;
}
